import React from 'react';
import { Zap, Shield, Wifi, LineChart, Bell, KeyRound, Check } from 'lucide-react';
import { CAPABILITIES } from '../mock';

const ICONS = { Zap, Shield, Wifi, LineChart, Bell, KeyRound };

export default function Capabilities() {
  return (
    <section id="features" className="relative">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mb-14">
          <div className="lg:col-span-2">
            <p className="text-[10px] tracking-[0.25em] font-mono gold-text">PLATFORM CAPABILITIES</p>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl md:text-5xl font-bold leading-[1.05] text-white">
              Built like trading infrastructure,
              <br />
              <span className="gold-text">not like a SaaS template.</span>
            </h2>
          </div>
          <div className="flex items-end">
            <p className="text-sm text-[#CDBE94] leading-relaxed">
              Every capability is subscriber-controlled, audit-logged, and locked behind paper-mode validation before live execution is permitted.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {CAPABILITIES.map((cap) => {
            const Icon = ICONS[cap.icon];
            return (
              <div
                key={cap.title}
                className="group relative border border-white/[0.08] rounded-md p-7 bg-[#0c0c0e] hover:border-[#d8b34a]/40 transition-colors duration-300"
              >
                <div className="flex items-start justify-between">
                  <div className="w-10 h-10 rounded-sm border gold-border flex items-center justify-center">
                    <Icon size={16} className="gold-text" strokeWidth={1.6} />
                  </div>
                  <span className="text-[10px] font-mono text-[#A99563] tracking-wider">{cap.version}</span>
                </div>
                <h3 className="mt-7 text-lg font-semibold text-white">{cap.title}</h3>
                <p className="mt-3 text-sm text-[#CDBE94] leading-relaxed">{cap.description}</p>
                <ul className="mt-5 space-y-2 pt-5 border-t border-[rgba(201,162,75,0.10)]">
                  {cap.points.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-[12px] text-[#CDBE94]">
                      <Check size={12} className="mt-1 gold-text shrink-0" strokeWidth={2.2} />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
